module.exports = __webpack_public_path__ + "static/media/Goals.a2352944.png";